<!-- Button trigger modal -->
<div class="bg-wrapper pt-2">
    <header class="mb-2 container">
        <div>
            <span class="brand"
                ><img src="assets/images/jsw-logo.png" alt="jsw-logo"
            /></span>
        </div>
    </header>

    <main class="password-change container justify-content-center py-5">
        <div class="row">
            <div class="col-md-5 offset-md-4">
                <div class="language-pane my-3">
                    <h3 class="mb-4">Reset Password</h3>
                    <p class="mb-4">Enter your new password</p>
                    <form
                        [formGroup]="resetData"
                        (ngSubmit)="onPasswordReset()"
                    >
                        <p *ngIf="isSuccess" class="success-block">
                            Your password was successfully changed.
                            <a routerLink="/"> Click here to login</a>
                        </p>
                        <p *ngIf="isError" class="help-block">
                            <span><i class="ri-error-warning-fill"></i></span>
                            Sorry, Your password couldn't be changed. Please try
                            again
                        </p>
                        <div class="mb-4">
                            <label class="form-label">New Password</label>
                            <p
                                class="help-block"
                                *ngIf="
                  resetData.get('newPassword')?.errors?.['required'] &&
                  resetData.get('newPassword')?.touched
                  "
                            >
                                New Password is requried
                            </p>
                            <p
                                class="help-block"
                                *ngIf="
                  resetData.get('newPassword')?.errors?.['pattern'] &&
                  resetData.get('newPassword')?.touched
                  "
                            >
                                Password must contain a symbol and special
                                character
                            </p>
                            <p
                                class="help-block"
                                *ngIf="
                  resetData.get('newPassword')?.errors?.['maxlength'] &&
                  resetData.get('newPassword')?.touched
                "
                            >
                                Password must not exceed 15 characters
                            </p>
                            <p
                                class="help-block"
                                *ngIf="
                  resetData.get('newPassword')?.errors?.['minlength'] &&
                  resetData.get('newPassword')?.touched
              "
                            >
                                Password must be at least 8 characters
                            </p>
                            <input
                                type="password"
                                class="form-control"
                                id="new_password"
                                placeholder="xxxxxxxxxxx"
                                formControlName="newPassword"
                            />
                        </div>
                        <div class="mb-4">
                            <label class="form-label">Confirm Password</label>
                            <p
                                class="help-block"
                                *ngIf="
              resetData.get('confirmPassword')?.errors?.['required'] &&
              resetData.get('confirmPassword')?.touched"
                            >
                                The Password does not match
                            </p>
                            <p
                                class="help-block"
                                *ngIf="
              resetData.get('confirmPassword')?.errors?.['matching'] &&
              resetData.get('confirmPassword')?.touched"
                            >
                                The Password does not match
                            </p>
                            <input
                                type="password"
                                class="form-control"
                                id="confirm_new_password"
                                placeholder="xxxxxxxxxxx"
                                formControlName="confirmPassword"
                            />
                        </div>

                        <div class="loader text-center mt-3" *ngIf="isLoading">
                            Loading ...
                        </div>

                        <button
                            [disabled]="resetData.invalid"
                            type="submit"
                            class="btn btn-primary"
                        >
                            Reset Password
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </main>

    <footer class="mt-auto d-flex justify-content-center">
        <p>
            Powered by
            <span class="brand-payex"
                ><img src="assets/images/payex-logo.png" alt="PayExLogo"
            /></span>
        </p>
    </footer>
</div>
